/**
 * #89 · Las dos insignias de la etiqueta individual, en un solo lugar.
 *
 * Existen porque el listado y la ficha pintan lo mismo, y dos copias de un
 * mapa de estado a color divergen. Cuando divergen, una etiqueta robada
 * aparece verde en una pantalla y roja en la otra, y la que decide es la que
 * el analista estaba mirando.
 *
 * Un estado o un veredicto que el servidor mande y este catálogo no conozca se
 * muestra **como texto crudo y en neutro**: nunca se lo asimila a otro que sí
 * conocemos. Es la misma decisión que toma `is_genuine()` en el backend —ante
 * un valor desconocido, no autentica— trasladada al color.
 */
import type { ReactNode } from 'react';

import { useI18n } from '@/i18n/useI18n';
import { Badge } from '@/ui/Badge';
import { stateLabel, unitStateTone, verdictKey, verdictTone } from './units';

export function StateBadge({ state }: { state: string }): ReactNode {
  const { t } = useI18n();
  return <Badge tone={unitStateTone(state)}>{stateLabel(state, t)}</Badge>;
}

export function VerdictBadge({ verdict }: { verdict: string }): ReactNode {
  const { t } = useI18n();
  const key = verdictKey(verdict);
  return <Badge tone={verdictTone(verdict)}>{key === null ? verdict : t(key)}</Badge>;
}
